var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon3Dots = function SvgIcon3Dots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.833 11.667c-.917 0-1.666-.75-1.666-1.667 0-.916.75-1.666 1.666-1.666.917 0 1.667.75 1.667 1.666 0 .917-.75 1.667-1.667 1.667m-5.833 0c-.917 0-1.667-.75-1.667-1.667S9.083 8.334 10 8.334s1.667.75 1.667 1.666c0 .917-.75 1.667-1.667 1.667m-5.833 0c-.917 0-1.667-.75-1.667-1.667s.75-1.666 1.667-1.666c.916 0 1.666.75 1.666 1.666 0 .917-.75 1.667-1.666 1.667"
  })));
};
export default SvgIcon3Dots;